import React from "react";
import { Icon } from "./Icon.jsx";

const SIZES = { sm: [26, 15], md: [30, 17], lg: [32, 20] };
const TONES = { default: "var(--fg-5)", nav: "var(--ico-nav)", danger: "var(--ac-red)", favorite: "var(--ac-amber-3)", quiet: "var(--fg-7)" };

// Die Werte unter dem Zeiger stehen als :hover-Regel an .erp-icon-btn in
// tokens/base.css; hier steht der Ruhewert als Rückfall der jeweiligen Variablen.
// Der aktive Knopf und die getönten Töne bleiben davon unberührt — sie gewinnen
// hier, weil der Zeiger an ihnen nichts ändern soll.
export function IconButton({ icon, tip, size = "md", tone = "default", bordered = false, badge, active = false, onClick, style = {} }) {
  const [box, glyph] = SIZES[size] || SIZES.md;
  const tinted = tone === "danger" || tone === "favorite";
  return (
    <button title={tip} aria-label={tip} onClick={onClick} className="erp-icon-btn"
      style={{
        position: "relative", display: "flex", alignItems: "center", justifyContent: "center",
        width: box, height: box, padding: 0,
        background: active ? "var(--bg-sel)" : "var(--icon-btn-hot-bg, transparent)",
        border: bordered ? "1px solid var(--icon-btn-hot-border, var(--line-d))" : "none",
        borderRadius: "var(--r-icon-button)",
        color: tinted ? TONES[tone] : active ? "var(--fg-2)" : "var(--icon-btn-hot-fg, " + TONES[tone] + ")",
        cursor: "pointer",
        transition: "background var(--dur-instant) ease, color var(--dur-instant) ease",
        ...style,
      }}>
      <Icon name={icon} size={glyph} />
      {badge != null ? (
        <span style={{
          position: "absolute", top: -2, right: -2, minWidth: 15, height: 15, padding: "0 4px", boxSizing: "border-box",
          display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "var(--r-pill)",
          background: "var(--ac-red-4)", color: "#fff", fontSize: 8.5, fontWeight: "var(--fw-bold)", lineHeight: "15px", letterSpacing: "-0.02em",
        }}>{badge}</span>
      ) : null}
    </button>
  );
}
